// extracted by mini-css-extract-plugin
module.exports = {"secondary-icon":"secondary-icon__3j6LU","icon":"icon__3Ug-x"};